<template>
    <div class="document-preview">
        <div class="document-preview_thumbnail">
            <VJoyIcon name="file-pdf" size="xsmall" color="neutral" />
        </div>
        <div class="document-preview_informations">
            <div class="document-preview_informations_name" data-testid="document-uploaded-title">
                {{ document.name }}
            </div>
            <div class="document-preview_informations_format">PDF</div>
        </div>
        <div class="document-preview_delete" title="Delete document">
            <VJoyIcon data-testid="document-uploaded-delete" size="xsmall" name="trash" color="error" @click="emit('delete')" />
        </div>
    </div>
</template>

<script setup lang="ts">
    import {VJoyIcon} from '@maltjoy/core-vue';

    defineProps<{document: File}>();

    const emit = defineEmits<{(e: 'delete'): void}>();
</script>

<style lang="scss" scoped>
    @use '@malt/joy-entrypoint' as joy;
    .document-preview {
        background-color: var(--joy-color-neutral-20);
        border-radius: var(--joy-core-radius-3);
        display: flex;
        flex-flow: row nowrap;
        gap: var(--joy-core-spacing-4);
        padding: var(--joy-core-spacing-2);
        max-width: 300px;
        position: relative;
        min-width: 0;
        &_thumbnail {
            height: 42px;
            width: 42px;
            background-color: var(--joy-color-success-10);
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: var(--joy-core-radius-2);
            flex: 0 0 auto;
        }
        &_informations {
            display: flex;
            flex-flow: column wrap;
            justify-content: center;
            flex: 1 1 auto;
            position: relative;
            min-width: 0;
            &_name {
                font-weight: var(--joy-font-weight-bold);
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                width: 100%;
            }
        }
        &_delete {
            justify-content: center;
            align-items: center;
            padding-right: var(--joy-core-spacing-2);
            display: flex;

            @include joy.screen_md(min) {
                display: none;
                :hover > & {
                    display: flex;
                }
            }

            :deep(.joy-icon) {
                cursor: pointer;
                transition: color 0.3s ease;
                &:hover {
                    color: var(--joy-color-border-error);
                }
            }
        }
    }
</style>
